import PropTypes from 'prop-types';
import { memo } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Amenities from '../../AmenitiesDetails';
import { checkDoShowTripConfirmationPricing } from '../../../../../../store/slices/user';
import { removePricingInformation } from '../../../../../../helpers/formatters/formatRoomDescription';

const RateDetail = ({ product }) => {
  const doShowPricingToClients = useSelector(checkDoShowTripConfirmationPricing);

  const additionalInfo = doShowPricingToClients
    ? product.additional_info
    : removePricingInformation(product.additional_info);

  return (
    <div className="col-span-9 mb-2 mt-1">
      {!additionalInfo &&
      !(product.amenities || []).length > 0 &&
      !(product.valueAdds || []).length > 0 ? (
        <i>Rate details not found!</i>
      ) : (
        <>
          {product.rooms[0].category && (
            <div className="mb-2">
              <b>Product category:</b> {product.rooms[0].category}
            </div>
          )}
          {product.amenities && product.amenities.length > 0 && (
            <div className="mb-2">
              <Amenities roomAmenities={product.amenities} />
            </div>
          )}
          {product.rooms &&
            product.rooms[0] &&
            product.rooms[0].bedTypes &&
            product.rooms[0].bedTypes.length > 0 && (
              <div className="mb-2">
                Bed type(s):{' '}
                {product.rooms[0].bedTypes.map((v) => (
                  <div key={v} className="inline mr-2">
                    {v}
                  </div>
                ))}
              </div>
            )}
          {product.valueAdds && product.valueAdds.length > 0 && (
            <div className="mb-2">Meal: {_.join(product.valueAdds, ', ')}</div>
          )}
          {additionalInfo && <div dangerouslySetInnerHTML={{ __html: additionalInfo }} />}
        </>
      )}
    </div>
  );
};

RateDetail.propTypes = {
  product: PropTypes.shape().isRequired,
};
export default memo(RateDetail);
